import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { HR } from 'foundations-components/transitional/components/HR';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Media, MediaBody, MediaLeft, MediaRight } from 'foundations-components/transitional/components/Media';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { ACTIONS, EVENTS, SCREENS } from '../../../constants/tracking';
import { useApp } from '../../../contexts/AppContext';
import { useTracking } from '../../../contexts/TrackingContext';
import { useFetchEmaStatus } from '../../../hooks/queries/useFetchEmaStatus';
import { EnterpriseManagedAuthActive } from './EnterpriseManagedAuthActive';
import { EnterpriseManagedAuthSetup } from './EnterpriseManagedAuthSetup';
import { EnterpriseManagedAuthTurnOffModal } from './EnterpriseManagedAuthTurnOffModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function EnterpriseManagedAuthTile() {
  var _data$trustedIssuerUr;
  const {
    data
  } = useFetchEmaStatus();
  const {
    appId,
    appName
  } = useApp();
  const {
    track
  } = useTracking();
  const [isOpen, setIsOpen] = useState(data.emaOptedIn);
  const [isConfirmingTurnOff, setIsConfirmingTurnOff] = useState(false);
  const [firstEmaClientConfig] = data.emaClientConfigs;
  if (!firstEmaClientConfig) {
    return null;
  }
  const accountId = String(firstEmaClientConfig.tenantId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Tile, {
      compact: true,
      children: [/*#__PURE__*/_jsx(TileSection, {
        children: /*#__PURE__*/_jsxs(Media, {
          align: "start",
          children: [/*#__PURE__*/_jsx(MediaLeft, {
            children: /*#__PURE__*/_jsx(IconHolder, {
              icon: TwoFAOutlineIcon,
              size: "400",
              padding: "200",
              borderRadius: "200",
              backgroundColor: "fill-accent-blue-subtle"
            })
          }), /*#__PURE__*/_jsxs(MediaBody, {
            children: [/*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h5",
                marginBlockEnd: "0",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.advanced.ema.title"
                })
              }), /*#__PURE__*/_jsx(Badge, {
                use: "beta",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.advanced.ema.beta"
                })
              })]
            }), /*#__PURE__*/_jsx(Paragraph, {
              color: "text-core-subtle",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.description"
              })
            })]
          }), /*#__PURE__*/_jsx(MediaRight, {
            children: /*#__PURE__*/_jsx(Toggle, {
              size: "extra-small",
              checked: isOpen,
              "aria-label": I18n.text('app-governance-lib.advanced.ema.title'),
              onChange: () => {
                track(EVENTS.PANEL_INTERACTED, {
                  screen: SCREENS.MANAGEMENT_MODAL_PANEL,
                  action: ACTIONS.EMA_TOGGLED,
                  actionValue: !isOpen,
                  appId,
                  appName
                });
                if (isOpen && data.emaOptedIn) {
                  setIsConfirmingTurnOff(true);
                } else {
                  setIsOpen(prev => !prev);
                }
              }
            })
          })]
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: isOpen,
        children: data.emaOptedIn ? /*#__PURE__*/_jsx(EnterpriseManagedAuthActive, {
          accountId: accountId,
          issuerUrl: (_data$trustedIssuerUr = data.trustedIssuerUrl) !== null && _data$trustedIssuerUr !== void 0 ? _data$trustedIssuerUr : ''
        }) : /*#__PURE__*/_jsx(EnterpriseManagedAuthSetup, {
          accountId: accountId,
          onCancel: () => setIsOpen(false)
        })
      }), isConfirmingTurnOff && /*#__PURE__*/_jsx(EnterpriseManagedAuthTurnOffModal, {
        onTurnedOff: () => {
          setIsConfirmingTurnOff(false);
          setIsOpen(false);
        },
        onClose: () => setIsConfirmingTurnOff(false)
      })]
    }), /*#__PURE__*/_jsx(HR, {})]
  });
}